import React from 'react'
import { Card } from 'react-bootstrap'

const PhotoRealistic = () => {
	return (
		<>
			<Card className="text-center rounded-0 no-border photo-realistic-card container">
				<Card.Body>
					<Card.Title className='photo-realistic-title'>バーチャルワールドに生命を吹き込む</Card.Title>
					<Card.Text className='photo-realistic-content pt-4 text-left'>
						グラフィックがなければ、バーチャル空間はただのデジタルブラックホールになってしまいます。優秀なグラフィック・アーティストやデザイナーのおかげで、パラコズマでは現実やファンタジーの環境をVRに取り込むことができます。
					</Card.Text>
					<Card.Text className='photo-realistic-content text-left'>
						1台の機械、1つの部屋、建物全体、街全体、ファンタジーな島など……プロジェクトが必要とするものが何であれ、パラコズマはリアルな3Dグラフィックを制作し、AR・VRのアプリケーションでユーザーに感動的な体験を提供した実績があります 
					</Card.Text>
				</Card.Body>
			</Card>
		
		</>
	)
}

export default PhotoRealistic
